import api from "./api";
import { generateErrorMessage } from "../utils/message";
import {
  extensionForType,
  readBlobErrorMessage,
  saveBlobResponse,
} from "../utils/downloadFile";


/*Monitorings*/
export const registerMonitoring = async (monitoringData) => {
  try {
    const response = await api.post("/ews/details", monitoringData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("register", "monitoring");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchMonitoringsFromAPI = async (page = 1, perPage = 10, search = "") => {
  try {
    const response = await api.get("/ews/details", {
      params: { page, per_page: perPage, ...search },
    });

    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "monitoring");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const deleteMonitoringsFromAPI = async (monitoringId) => {
  try {
    const response = await api.delete(`/ews/${monitoringId}`, {
      params: { monitoring_id: monitoringId },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("delete data", "monitoring");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const registerBNFFromAPI = async (data) => {
  try {
    const response = await api.post(`/bnf/reports-four`, data);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("delete data", "monitoring");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const fetchMonitoringsById = async (monitoringId) => {
  try {
    const response = await api.get(`/ews/${monitoringId}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data monitoring", "monitoring");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const updateMonitoring = async (id, monitoringData) => {
  try {
    const response = await api.put(`/ews/${id}`, monitoringData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("update", "monitoring");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const uploadMonitoringFileToAPI = async (formData) => {
  try {
    const response = await api.post("/inventories/submit-excel-monitoring", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("upload monitoring file", "monitoring");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


/**
 * Stock report download for the monitoring detail page.
 *
 * `vendor_name` is really the vendor_code — the name is carried over from the
 * legacy signature; the endpoint matches on vendor_code.
 *
 * The endpoint streams the xlsx/pdf back with Content-Disposition. It used to
 * write the file to disk and return `{ data: { filePath } }`, and this function
 * still read that field — on a binary body it is always undefined, so every
 * download ended in "File URL not found in response." and nothing was saved.
 */
export const downloadMonitoringFileFromAPI = async (fileType, vendor_name) => {
  try {
    const response = await api.post(
      `/ews/download/display-ews/${fileType}/stock-report/${vendor_name}`,
      {},
      { responseType: "blob" },
    );

    saveBlobResponse(response, {
      fileType,
      fallbackName: `stock_report_${vendor_name || "all"}.${extensionForType(fileType)}`,
    });

    return { success: true };
  } catch (error) {
    const fallback = generateErrorMessage("download monitoring file", "monitoring");
    throw new Error(await readBlobErrorMessage(error, fallback));
  }
};
